import { configureStore } from "@reduxjs/toolkit";
import currentUserReducers from "./currentUserSlice.js";
import currentTeamReducers from "./currentTeamSlice.js";
export default configureStore({
    reducer: {
        current_user: currentUserReducers,
        current_team: currentTeamReducers,
    },
});
